module.exports = __webpack_public_path__ + "img/asegrup.2c74425d.png";